import Vue from 'vue'
import Vuex from 'vuex'
import modules from '@/store/modules-1'
import modulesTwo from '@/store/modules-2'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    ...modules,
    ...modulesTwo
  }
})
